import { AnnotationPlugin } from '@st/document-viewer-kit'
import { StampAnnotation } from '@st/sdk'
import { SignOffsToolState } from '~/st-doc-viewer/annotations'
import { SignOffAnnotationElement } from './ui'

export function signOffsPlugin(): AnnotationPlugin<StampAnnotation, SignOffsToolState> {
  return {
    name: 'sign_offs',
    initialToolState: { name: 'sign_offs', settings: {} },
    Element: SignOffAnnotationElement,
    handlesAnnotation: (annotation) =>
      annotation.type === 'stamp' && (annotation as StampAnnotation).stampType === 'sign_off'
  }
}
